import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import sgeGoldLogo from "../imagem/sge_logo_gold.webp";
import ereLogo from "../imagem/logoere.png";
import logo2 from "../imagem/logo2.png";
import beautyLogo from "../imagem/logo_beauty_oficial.webp";
import { BsWhatsapp } from "react-icons/bs";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import AlicerceLogo from "./pages/AlicerceLogo";
import HemathClinLogo from "./pages/HemathClinLogo";
import VitalisLogo from "./pages/VitalisLogo";

function Portfolio() {
  const projects = [
    {
      title: "SGE Pro - Gestão de Eventos",
      img: sgeGoldLogo,
      description: "Plataforma completa para controle de reservas, cronograma interativo e logística de grandes eventos.",
      link: "/sge-pro",
    },
    {
      title: "ERE - Gestão Operacional",
      img: ereLogo,
      description: "Pedidos, estoque com reservas por data, clientes e ponto eletrônico da equipe em um só lugar.",
      link: "/ere",
    },
    {
      title: "Dmarks - Locação de Mobiliário",
      img: logo2,
      description: "Sistema sob medida para locação de móveis e estruturas para eventos e estandes.",
      link: "/dmarks",
    },
    {
      title: "Beauty Agenda - Salões e Studios",
      img: beautyLogo,
      description: "SaaS de agendamento online para salões de beleza, com gestão de clientes e planos escalonáveis.",
      link: "/beauty-agenda",
    },
    {
      title: "HemathClin - Clínicas de Saúde",
      icon: <HemathClinLogo size={48} />,
      description: "Gestão clínica com prontuário digital, agenda multiprofissional e controle de pacientes.",
      link: "/hemathclin",
    },
    {
      title: "Vitalis - Plataforma para Terapeutas",
      icon: <VitalisLogo size={48} />,
      description: "Ecossistema multi-tenant com cursos, consultas, e-books e comunidade para terapeutas.",
      link: "/vitalis",
    },
    {
      title: "WhatsApp Extractor",
      icon: <BsWhatsapp size={44} color="#25d366" />,
      description: "Serviço de extração automatizada de contatos via WhatsApp com painel administrativo dedicado.",
      link: "/whatsapp-extractor",
    },
    {
      title: "Alicerce - Manutenção Predial",
      icon: <AlicerceLogo size={48} />,
      description: "Orçamento a aprovação por link público e acompanhamento de obra para eletricista, encanador, pedreiro e mais.",
      link: "/alicerce",
    },
  ];

  const partners = [
    <img src={logo2} alt="Dmarks" className="partner-img-dark" loading="lazy" />,
    <img src={sgeGoldLogo} alt="SGE Pro" className="partner-img-dark" loading="lazy" />,
    <AlicerceLogo size={32} showWordmark />,
    <img src={beautyLogo} alt="Beauty Agenda" className="partner-img-dark" loading="lazy" />,
  ];

  const testimonials = [
    {
      name: "Ewerton Gomes",
      company: "SGE Pro Customer",
      text: "A transição para o SGE Pro revolucionou nossa logística. O mapa de reservas é o mais fluido que já utilizamos.",
      img: sgeGoldLogo,
    },
    {
      name: "Casal Madry",
      company: "Alicerce (ex-Predilar Caça Vazamentos)",
      text: "O sistema personalizado atendeu perfeitamente às nossas necessidades. Equipe super profissional e dedicada.",
      logoNode: <AlicerceLogo size={32} />,
    },
    {
      name: "Gabriel",
      company: "Dmarks",
      text: "Eu recomendo o serviço da Henrimack Sistemas a todos que necessitam de soluções automatizadas para o seu negócio.",
      img: logo2,
    },
  ];

  const [current, setCurrent] = useState(0);
  const [, setDirection] = useState(1);

  const handleNav = (newIndex) => {
    setDirection(newIndex > current ? 1 : -1);
    setCurrent(newIndex);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setDirection(1);
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  return (
    <section id="portfolio" className="portfolio-elite py-5">
      <Container>
        <div className="text-center mb-5" data-aos="fade-up">
          <h6 className="text-gold text-uppercase fw-bold mb-3 ls-3">Casos de Sucesso</h6>
          <h2 className="section-title-premium">Ecossistemas em <span className="highlight-gold">Produção</span></h2>
          <p className="section-subtitle-premium mx-auto max-w-700">
            Explore as soluções de alta densidade que desenvolvemos para empresas que buscam o estado da arte em software.
          </p>
        </div>

        <Row className="g-4 mb-5">
          {projects.map((project, index) => (
            <Col lg={3} md={6} key={index} data-aos="fade-up">
              <Card className="portfolio-card-luxury h-100">
                <div className="portfolio-img-wrap">
                  {project.img
                    ? <Card.Img src={project.img} alt={project.title} className="portfolio-img-zoom" />
                    : <div className="portfolio-icon-fallback">{project.icon}</div>}
                  <div className="portfolio-overlay">
                    <Button as={Link} to={project.link} className="btn-view-project">Explorar Sistema</Button>
                  </div>
                </div>
                <Card.Body className="p-4 d-flex flex-column text-center">
                  <h5 className="portfolio-title-text mb-3">{project.title}</h5>
                  <p className="portfolio-desc-text flex-grow-1">{project.description}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Slider de Logos Dark */}
      <div className="partners-dark-container py-5 border-top border-bottom border-dark mt-5" style={{ overflow: 'hidden' }}>
        <Container>
          <div className="partners-wrapper" style={{ overflow: 'hidden', position: 'relative' }}>
            <div className="partners-track">
              {partners.concat(partners).map((logo, idx) => (
                <div key={idx} className="partner-slot-dark">{logo}</div>
              ))}
            </div>
          </div>
        </Container>
      </div>

      {/* Depoimentos Elite */}
      <Container className="py-10 mt-5">
        <div className="testimonial-elite-box mx-auto">
          <AnimatePresence mode="wait">
            <motion.div
              key={current}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 1.05 }}
              transition={{ duration: 0.6 }}
              className="testimonial-content-elite text-center"
            >
              <div className="quote-icon mb-4">“</div>
              <p className="testimonial-text-elite mb-5">{testimonials[current].text}</p>
              <div className="d-flex align-items-center justify-content-center gap-3">
                {testimonials[current].logoNode
                  ? <div className="client-logo-mini d-flex align-items-center">{testimonials[current].logoNode}</div>
                  : <img src={testimonials[current].img} alt="" className="client-logo-mini" />}
                <div className="text-start">
                  <h6 className="fw-bold text-white mb-0">{testimonials[current].name}</h6>
                  <span className="small text-gold">{testimonials[current].company}</span>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
          <div className="dots-container mt-4 d-flex justify-content-center gap-2">
            {testimonials.map((_, idx) => (
              <div
                key={idx}
                onClick={() => handleNav(idx)}
                className={`dot-luxury ${idx === current ? 'active' : ''}`}
              />
            ))}
          </div>
        </div>
      </Container>

      <style>{`
        .portfolio-elite {
          background-color: #050505;
          color: #fff;
          font-family: 'Inter', sans-serif;
          padding-top: 10rem !important;
          padding-bottom: 5rem !important;
        }

        .ls-3 { letter-spacing: 3px; font-size: 0.8rem; }
        .max-w-700 { max-width: 700px; }

        .portfolio-card-luxury {
          background: #0f0f0f;
          border: 1px solid #1a1a1a;
          border-radius: 20px;
          overflow: hidden;
          transition: all 0.4s ease;
        }

        .portfolio-card-luxury:hover {
          border-color: #e4a87a;
          transform: translateY(-5px);
        }

        .portfolio-img-wrap {
          height: 200px;
          overflow: hidden;
          position: relative;
          background: #151515;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
        }

        .portfolio-icon-fallback {
          display: flex; align-items: center; justify-content: center;
          width: 100%; height: 100%;
        }

        .portfolio-img-zoom {
          max-height: 100%;
          width: auto;
          transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .portfolio-card-luxury:hover .portfolio-img-zoom {
          transform: scale(1.1);
        }

        .portfolio-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .portfolio-card-luxury:hover .portfolio-overlay {
          opacity: 1;
        }

        .btn-view-project {
          background: #e4a87a;
          color: #000;
          border: none;
          padding: 0.6rem 1.5rem;
          border-radius: 50px;
          font-weight: 700;
          font-size: 0.85rem;
          text-transform: uppercase;
        }

        .portfolio-title-text { font-weight: 800; font-size: 1.1rem; color: #fff; }
        .portfolio-desc-text { font-size: 0.85rem; color: #999; line-height: 1.6; }

        .partners-track {
           display: flex;
           gap: 5rem;
           animation: scrollLogos 40s linear infinite;
           width: max-content;
        }

        .partner-img-dark {
           height: 50px;
           opacity: 0.4;
           filter: grayscale(1);
           transition: all 0.3s ease;
        }

        .partner-img-dark:hover {
           opacity: 1;
           filter: none;
           transform: scale(1.1);
        }

        .partner-slot-dark {
           display: flex;
           align-items: center;
           height: 50px;
           opacity: 0.4;
           filter: grayscale(1);
           transition: all 0.3s ease;
        }

        .partner-slot-dark:hover {
           opacity: 1;
           filter: none;
           transform: scale(1.1);
        }

        .partner-slot-dark .partner-img-dark {
           opacity: 1;
           filter: none;
        }

        @keyframes scrollLogos {
           0% { transform: translateX(0); }
           100% { transform: translateX(-50%); }
        }

        .testimonial-elite-box {
           max-width: 800px;
           background: linear-gradient(135deg, #0f0f0f, #151515);
           border: 1px solid #222;
           border-radius: 40px;
           padding: 5rem 4rem;
           position: relative;
        }

        .quote-icon { font-size: 5rem; line-height: 1; color: #e4a87a; opacity: 0.3; }
        .testimonial-text-elite { font-size: 1.5rem; font-weight: 500; font-style: italic; color: #eee; }
        .client-logo-mini { height: 40px; border-radius: 10px; }

        .dot-luxury { width: 10px; height: 10px; border-radius: 50%; border: 1px solid #444; cursor: pointer; transition: all 0.3s; }
        .dot-luxury.active { background: #e4a87a; border-color: #e4a87a; width: 30px; border-radius: 10px; }

        @media (max-width: 768px) {
           .testimonial-elite-box { padding: 3rem 1.5rem; }
           .testimonial-text-elite { font-size: 1.2rem; }
        }
      `}</style>
    </section>
  );
}

export default Portfolio;
